/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable arrow-body-style */
/* eslint-disable spaced-comment */
import axios from 'axios';
import { environment } from '../environment/environment';
import { OrderState } from '../store/ducks/order/types';
import { Customer } from './types';
import { getTokenJwt, saveTokenJwt } from './functions';

import { LocalStorageName } from '../utils/Utils';

import { APPLICATION_ID } from '../shared/defs';

export const api = axios.create({
  baseURL: environment.REACT_APP_API_URL,
});

export const geocode = axios.create({
  baseURL: environment.REACT_APP_GEOCODE_URL,
});

export const jwtRequest = async () => {
  const url = `${environment.REACT_APP_API_URL}/auth/token`;
  await axios({
    url,
    method: 'POST',
    headers: environment.headers,
    data: {
      username: environment.REACT_APP_API_USERNAME,
      password: environment.REACT_APP_API_PASSWORD,
    },
  })
    .then(res => {
      const token = res?.data.token;
      saveTokenJwt(token);
      // window.dispatchEvent(new Event('storage'));
      window.dispatchEvent(
        new StorageEvent('storage', {
          key: `${LocalStorageName}token:${APPLICATION_ID}`,
          newValue: token,
        }),
      );
    })
    .catch(err => {
      console.log('JWT ERR: ', err);
    });
};

export const getSettings = async () => {
  const url = `${environment.REACT_APP_API_URL}/settings`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error settings att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getMerchantList = async () => {
  const url = `${environment.REACT_APP_API_URL}/merchants?includeAll=true&$orderby=status desc`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getMerchantList att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getMerchant = async (URI: string) => {
  
  // if(URI === 'undefined' || URI === undefined) {
  //   window.location.href = '/';
  // }
  
  const url = `${environment.REACT_APP_API_URL}/merchants/${URI ||
    window.location.pathname.substring(1).split('/')[0]}`;

  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
      // accept: 'application/json',
      // Authorization:
      //   'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im1ldWNhcnJpbmhvLmFwcCIsImVtYWlsIjoicmlsZG8ubWFzdGVyQGdtYWlsLmNvbSIsImp0aSI6ImUyNmQzZGRlLWZhOWYtNDkyZi05NTdkLTk4NGU1N2RiNWY4ZiIsInR5cCI6IkJlYXJlciIsInJvbGUiOiJBUFAiLCJzdWIiOiI3M2VjZGI2Ny05M2Y5LTQ0ZDgtOWRhNi01NmQyMDdmODdlMTkiLCJpYXQiOjE2MzAwMTAzMTksImV4cCI6MTYzMDAxMDkxOSwiaXNzIjoiQVBJIiwiYXVkIjoiKi5tZXVjYXJyaW5oby5kZWxpdmVyeSJ9.2Tu7ELTKUntP6IbMwshB_8xqVxQlhOqqejLL6h1CsBY',
    },
  })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getMerchant att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getAddressFromAPI = async (cep: string) => {
  const url = `${environment.REACT_APP_API_URL}/services/cep/${cep.replace(
    '-',
    '',
  )}`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getAddress att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getActualDay = () => {
  const daysOfWeek = [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ];
  const now = new Date().getDay();
  return daysOfWeek[now];
};

export const getMerchantCategories = async (URI: string) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/categories?merchantUrlCode=${URI}&availability=AVAILABLE&includeProducts=true&limitProducts=500`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getCategories att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getMerchantProducts = async (URI: string) => {
  return [];
  // const jwt = await getTokenJwt(true);
  // const url = `${environment.REACT_APP_API_URL}/products?merchantUrlCode=${URI}&availability=AVAILABLE`;
  // const result = await axios({
  //   url,
  //   method: 'GET',
  //   headers: {
  //     ...environment.headers,
  //     Authorization: `Bearer ${jwt}`,
  //   },
  // })
  //   .then(res => {
  //     return res.data;
  //   })
  //   .catch(err => {
  //     console.log(err.message);
  //     // if (err.response.status === 401) {
  //     //   removeLocalStorage('token');

  //     //   console.log('Token expired! Refreshing...');
  //     //   return jwtRequest().then(async jwtNew =>
  //     //     axios({
  //     //       url,
  //     //       method: 'GET',
  //     //       headers: {
  //     //         ...environment.headers,
  //     //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
  //     //       },
  //     //     })
  //     //       .then(response => response.data)
  //     //       .catch(error => {
  //     //         console.log('Error getProducts att Token: ', error.response);
  //     //       }),
  //     //   );
  //     // }
  //     return false;
  //   });
  // return result;
};

export const getShoppingByUrlCode = async (URL: string) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/shops/${URL}`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getProducts att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

interface shopMerchantsResquestTypes {
  id: string;
  pageNumber: number;
  pageSize: number;
  find: string;
  city: string;
  state: string;
  segmentCode: string;
}

export const getShoppingMerchants = async ({
  id = '',
  find = '',
  city = '',
  pageSize = 9,
  segmentCode = '',
}: any) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/shops/${id}/merchants?&find=${find}&pageSize=${pageSize}&city=${city}&segmentCode=${segmentCode}`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getProducts att Token: ', error.response);
      //       }),
      //   );
      // }
      return err;
    });
  return result;
};

export const getVariationItems = async (
  variationId: string,
  itemId: string,
) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/variations/${variationId}/items/${itemId}`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log(
      //           'Error getVariationItems att Token: ',
      //           error.response,
      //         );
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getProductVariations = async (productId: string) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/products/${productId}/variations`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');
      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log(
      //           'Error getProductVariations att Token: ',
      //           error.response,
      //         );
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getProductVariationById = async (
  productId: string,
  variationId: string,
) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/products/${productId}/variations/${variationId}`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');
      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log(
      //           'Error getProductVariationById att Token: ',
      //           error.response,
      //         );
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getOrder = async (orderId: string) => {
  const jwt = await getTokenJwt(true);
  const url = `${environment.REACT_APP_API_URL}/orders/${orderId}`;
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');
      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getOrder att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const sendOrder = async (data: OrderState) => {
  const url = `${environment.REACT_APP_API_URL}/orders`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'POST',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
    data,
  })
    .then(res => {
      // console.log('ORder ok: ', res.data);
      return res.data;
    })
    .catch(err => {
      console.log('Error of order: ', err.response);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'POST',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //       data,
      //     })
      //       .then(response => {
      //         console.log('Success send order: ', response.data);
      //         return response.data;
      //       })
      //       .catch(error => {
      //         console.log('Error sendOrder att Token: ', error.response);
      //       }),
      //   );
      // }
      return err.response;
    });
  return result;
};

export const registerCustomer = async (data: Customer) => {
  const url = `${environment.REACT_APP_API_URL}/customers`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'POST',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
    data,
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log('Error of customer: ', err.response);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'POST',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //       data,
      //     })
      //       .then(response => {
      //         console.log('Success send customer: ', response.data);
      //         return response;
      //       })
      //       .catch(error => {
      //         console.log('Error sendCustomer att Token: ', error.response);
      //       }),
      //   );
      // }
      return err.response;
    });
  return result;
};

export const getStates = async () => {
  const url = `${environment.REACT_APP_API_URL}/services/states`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getStates att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getCities = async (state: string) => {
  const url = `${environment.REACT_APP_API_URL}/services/cities/${state}`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getCities att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getAllMerchants = async (
  pageNumber = 1,
  pageSize = 9,
  find = '',
  city = '',
  state = '',
  segmentCode = '',
) => {
  const url = `${environment.REACT_APP_API_URL}/merchants?pageNumber=${pageNumber}&pageSize=${pageSize}&find=${find}&city=${city}&state=${state}&segmentCode=${segmentCode}&includeAll=true&onlyActive=true&onlyMarketplace=true`;
  const jwt = await getTokenJwt(true);
  let result;
  try {
    result = await axios({
      url,
      method: 'GET',
      headers: {
        ...environment.headers,
        Authorization: `Bearer ${jwt}`,
      },
    }).then(res => {
      return res;
    });
    return result;
  } catch (e) { // @ts-ignore
    console.log(e.message);  // @ts-ignore
    const res = { data: [], headers: e?.response?.headers };
    // if (e.response.status === 401) {
    //   removeLocalStorage('token');
    //   console.log('Token expired! Refreshing...');
    //   return jwtRequest().then(async jwtNew =>
    //     axios({
    //       url,
    //       method: 'GET',
    //       headers: {
    //         ...environment.headers,
    //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
    //       },
    //     })
    //       .then(response => {
    //         return response;
    //       })
    //       .catch(error => {
    //         console.log('Error getAllMerchants att Token: ', error.response);
    //         return { data: [], headers: error.response.headers };
    //       }),
    //   );
    // }
    return res;
  }
};

export const getAllShoppings = async (
  pageNumber = 1,
  pageSize = 9,
  find = '',
) => {
  const url = `${environment.REACT_APP_API_URL}/shops?pageNumber=${pageNumber}&pageSize=${pageSize}&find=${find}&includeAll=true&onlyActive=true&onlyMarketplace=true`;
  const jwt: string = await getTokenJwt(true);
  let result;
  try {
    result = await axios({
      url,
      method: 'GET',
      headers: {
        ...environment.headers,
        Authorization: `Bearer ${jwt}`,
      },
    }).then(res => {
      return res;
    });
    return result;
  } catch (e) {  // @ts-ignore
    console.log(e.message); // @ts-ignore
    // console.log(`catch: ${jwt}`);
    const res = { data: [], headers: e.response?.headers };
    // if (e.response.status === 401) {
    //   removeLocalStorage('token');
    //   console.log('Token expired! Refreshing...');
    //   return jwtRequest().then(async jwtNew =>
    //     axios({
    //       url,
    //       method: 'GET',
    //       headers: {
    //         ...environment.headers,
    //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
    //       },
    //     })
    //       .then(response => {
    //         return response;
    //       })
    //       .catch(error => {
    //         console.log('Error getAllMerchants att Token: ', error.response);
    //         return { data: [], headers: error.response.headers };
    //       }),
    //   );
    // }
    return res;
  }
};

export const getSegments = async () => {
  const url = `${environment.REACT_APP_API_URL}/settings/market/segments`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');
      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getSegments att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getRatings = async (id: string) => {
  const url = `${environment.REACT_APP_API_URL}/orders/ratings?merchantId=${id}`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getRatings att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const getFavorite = async (
  customerId: string | undefined,
  productId: string,
) => {
  const url = `${environment.REACT_APP_API_URL}/customers/${customerId}/favorites/products/${productId}`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.status)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getFavorite att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};

export const setFavorite = async (
  customerId: string | undefined,
  productId: string,
) => {
  const url = `${environment.REACT_APP_API_URL}/customers/${customerId}/favorites/products/${productId}`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'PATCH',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.status)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error setFavorite att Token: ', error.response);
      //       }),
      //   );
      // }
      return err.status;
    });
  return result;
};

export const getAvatars = async () => {
  const url = `${environment.REACT_APP_API_URL}/settings/avatars`;
  const jwt = await getTokenJwt(true);
  const result = await axios({
    url,
    method: 'GET',
    headers: {
      ...environment.headers,
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then(res => res.data)
    .catch(err => {
      console.log(err.message);
      // if (err.response.status === 401) {
      //   removeLocalStorage('token');

      //   console.log('Token expired! Refreshing...');
      //   return jwtRequest().then(async jwtNew =>
      //     axios({
      //       url,
      //       method: 'GET',
      //       headers: {
      //         ...environment.headers,
      //         Authorization: `${jwtNew.data.tokenType} ${jwtNew.data.token}`,
      //       },
      //     })
      //       .then(response => response.data)
      //       .catch(error => {
      //         console.log('Error getAvatars att Token: ', error.response);
      //       }),
      //   );
      // }
      return false;
    });
  return result;
};
